"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'fixed',
        bottom: 0,
        left: '50%',
        width: '55%',
        transform: 'translateX(-50%) translateY(0)',
        backgroundColor: theme.teal1,
        borderRadius: '5px 5px 0 0',
        color: theme.white1,
        boxShadow: `0px 3px 20px rgba(48, 206, 202, 0.2)`,
        height: 60,
        fontSize: 14,
        lineHeight: '20px',
        textAlign: 'center',
        transition: 'transform 150ms linear',
        opacity: 1,
        zIndex: 6,
        padding: 10,
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        '& strong': {
            fontWeight: 800
        }
    },
    ready: {
        opacity: 0,
        transform: 'translateX(-50%) translateY(100%)'
    },
    error: {
        backgroundColor: theme.warningRed
    },
    btn: {
        flexShrink: 0,
        margin: '0 4px',
        color: theme.white1,
        '&:focus': {
            outline: 'none'
        }
    },
    message: {
        flexGrow: 1,
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical'
    },
    clickBtn: {
        extend: 'btn',
        border: `1px solid ${theme.white1}`,
        borderRadius: 2,
        padding: '9px 15px',
        fontWeight: 600,
        fontSize: 11,
        lineHeight: '14px',
        textTransform: 'uppercase'
    }
});
//# sourceMappingURL=snackbars.style.js.map